/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import purchase from './purchase'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<purchase/>',
  components: { purchase }
})



// WEBPACK FOOTER //
// ./src/pages/purchase/index.js